var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.lines),function(item){return _c('product',{key:item.index,attrs:{"product":item.product_obj,"showAmount":true,"cartLine":item,"basketId":item.basket_id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }